import React, { Component } from "react";
import { withApollo } from "react-apollo";

class FooterShade extends Component {
  render() {
    return <footer className="content-info"></footer>;
  }
}

export default withApollo(FooterShade);
